var layout_default = {
  "layout": "EVFA8",
  "cell": "_4YBTa"
};
export {
  layout_default as default
};
//# sourceMappingURL=layout-scss.js.map
